import React from "react"
import PropTypes from "prop-types"

class ToggleButton extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
      return(
        <div
          className='select_button_primary'
          style={{padding: 5, paddingLeft: 24, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', backgroundColor: this.props.pro? '#F48FB1' : '#03A9F4'}}>
          <div>{this.props.buttonText}</div>
          <label className="switch">
            <input type="checkbox" checked={this.props.selected} readOnly={true} onChange={() => this.props.onClick()} />
            <span className="slider round"></span>
          </label>
        </div>
      )
  }
}

export default ToggleButton;
